module.exports = __webpack_public_path__ + "static/media/incident_category-structural.934b8701.svg";